import React from "react";
import { FiSearch, FiFilter } from "react-icons/fi";
import { strings } from "../../../strings/strings";

const ContactRequestFilters = ({
  searchQuery,
  setSearchQuery,
  sortBy,
  setSortBy,
  totalRequests,
}) => {
  return (
    <div className="bg-white dark:bg-slate-900 rounded-2xl border border-gray-200 dark:border-slate-800 p-4 mb-6 shadow-sm">
      <div className="flex flex-col lg:flex-row gap-4 items-center justify-between">
        <div className="flex flex-col sm:flex-row items-center gap-4 w-full lg:w-auto">
          <div className="relative w-full sm:w-80">
            <FiSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 w-5 h-5" />
            <input
              type="text"
              placeholder={strings.SEARCH_CONTACTS}
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="w-full pl-11 pr-4 py-2.5 bg-gray-50 dark:bg-slate-800 border-none rounded-xl focus:ring-2 focus:ring-primary/20 dark:text-white transition-all"
            />
          </div>
          
          <div className="flex items-center gap-2 text-sm text-gray-500 dark:text-gray-400 whitespace-nowrap">
            <span className="font-medium text-primary">{totalRequests}</span>
            <span>{strings.RESULTS}</span>
          </div>
        </div>

        <div className="flex items-center gap-3 w-full lg:w-auto overflow-x-auto pb-2 lg:pb-0">
          <div className="flex items-center gap-2 px-3 py-2 bg-gray-50 dark:bg-slate-800 rounded-xl">
            <FiFilter className="text-gray-400 w-4 h-4" />
            <select
              value={sortBy}
              onChange={(e) => setSortBy(e.target.value)}
              className="bg-transparent border-none text-sm font-medium text-gray-600 dark:text-gray-300 focus:ring-0 cursor-pointer"
            >
              <option value="desc">{strings.NEWEST_FIRST}</option>
              <option value="asc">{strings.OLDEST_FIRST}</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactRequestFilters;
